export enum PatientSearchConstants {
  SET_FIRST_NAME = 'patientSearch/SET_FIRST_NAME',
  SET_LAST_NAME = 'patientSearch/SET_LAST_NAME',
  SET_DOB = 'patientSearch/SET_DOB',
  SET_SSN = 'patientSearch/SET_SSN',
  RESET_SEARCH = 'patientSearch/RESET_SEARCH',
  GET_PATIENT_SEARCH_RESULTS = 'patientSearch/GET_PATIENT_SEARCH_RESULTS',
  GET_PATIENT_RECORD = 'patientSearch/GET_PATIENT_RECORD',
  SET_PATIENT_SEARCH_RESULTS = 'patientSearch/SET_PATIENT_SEARCH_RESULTS',
  SET_ARE_RESULTS_LOADING = 'patientSearch/SET_ARE_RESULTS_LOADING',
  SET_SEARCH_STATE = 'patientSearch/SET_SEARCH_STATE',
  RESET_SEARCH_STATE = 'patientSearch/RESET_SEARCH_STATE',
  SET_SHOW_IMPORT_DATA_CONFIRMATION_ALERT = 'patientSearch/SET_SHOW_IMPORT_DATA_CONFIRMATION_ALERT',
  SET_TOTAL_AVAILABLE_RESULTS = 'patientSearch/SET_TOTAL_AVAILABLE_RESULTS',
  SET_TOTAL_SEARCH_RESULTS = 'patientSearch/SET_TOTAL_SEARCH_RESULTS',
  SET_SHOW_SHARED_SERVICE_SEARCH_RESULTS_MESSAGE = 'patientSearch/SET_SHOW_SHARED_SERVICE_SEARCH_RESULTS_MESSAGE',
  SET_IS_PATIENT_DATA_LOADING = 'patientSearch/SET_IS_PATIENT_DATA_LOADING',
  SET_IS_SEARCH_IMPORT = 'patientSearch/SET_IS_SEARCH_IMPORT',
  GET_PATIENT_SEARCH_DATA = 'patientSearch/GET_PATIENT_SEARCH_DATA',
}
